export const W8W9_REQUEST_POPUP_TEXT = 'You already have requests in your account.';
export const CONTACT_FOR_PRICING = 'Please contact us for pricing';
export const NO_PLAN_SELECTED_WARNING_TEXT = "Please select a plan before moving forward";
export const REQUEST_PURCHASE_LABEL = `Request Purchase`;

export const W8W9_REQUEST_STATE = {
    ACTIONS_LOADING: "ACTIONS_LOADING",
    ACTIONS_READY: "ACTIONS_READY",
    PREPAY_LOADING: "PREPAY_LOADING",
    PREPAY_READY: "PREPAY_READY",
}

export const W8W9_REQUEST_MESSAGE_MAP = {
[W8W9_REQUEST_STATE.ACTIONS_LOADING]: "",
[W8W9_REQUEST_STATE.PREPAY_LOADING]: "",
}